import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createVNode as _createVNode, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "block w-full whitespace-normal leading-tight text-lg font-extrabold text-blue-600 max-[600px]:block min-[601px]:hidden" }
const _hoisted_2 = { class: "hidden whitespace-nowrap text-lg font-extrabold text-blue-600 min-[601px]:inline" }
const _hoisted_3 = ["aria-expanded", "aria-label"]
const _hoisted_4 = { class: "max-[600px]:hidden" }
const _hoisted_5 = {
  key: 0,
  class: "bg-orange-50 border border-orange-200 rounded-lg p-3 mb-4"
}
const _hoisted_6 = { class: "text-orange-800 text-sm" }
const _hoisted_7 = {
  key: 1,
  class: "bg-blue-50 border border-blue-200 rounded-lg p-3 mb-4"
}
const _hoisted_8 = {
  key: 0,
  class: "mb-2 space-y-2"
}
const _hoisted_9 = { class: "text-sm text-gray-800" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "text-xs text-gray-400" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 2,
  class: "mb-6"
}
const _hoisted_14 = { class: "hidden lg:block overflow-x-auto rounded border border-gray-200" }
const _hoisted_15 = { class: "min-w-full divide-y divide-gray-100" }
const _hoisted_16 = { class: "bg-gray-50/80" }
const _hoisted_17 = {
  key: 0,
  class: "px-2 py-1.5 text-center text-xs font-semibold text-black uppercase tracking-wider border-l border-gray-200"
}
const _hoisted_18 = { class: "bg-white divide-y divide-gray-100" }
const _hoisted_19 = { class: "bg-gray-100 border-t-2 border-gray-300" }
const _hoisted_20 = ["colspan"]
const _hoisted_21 = { class: "flex items-center justify-between" }
const _hoisted_22 = { class: "text-sm font-bold text-black uppercase" }
const _hoisted_23 = { class: "text-sm font-semibold text-blue-700 bg-blue-100 px-2 py-0.5 rounded" }
const _hoisted_24 = { class: "px-2 py-1.5" }
const _hoisted_25 = { class: "flex items-start gap-2" }
const _hoisted_26 = { class: "w-32 h-32 flex-shrink-0 flex items-center justify-center bg-gray-50 rounded border border-gray-200 overflow-hidden" }
const _hoisted_27 = ["src", "alt", "onClick"]
const _hoisted_28 = {
  key: 1,
  class: "fas fa-tshirt text-black text-lg"
}
const _hoisted_29 = { class: "flex-1 min-w-0" }
const _hoisted_30 = { class: "text-sm text-black leading-tight mb-0.5" }
const _hoisted_31 = { class: "text-black" }
const _hoisted_32 = { class: "text-sm text-black leading-tight mb-0.5" }
const _hoisted_33 = { class: "text-black" }
const _hoisted_34 = { class: "text-sm text-black leading-tight mb-0.5" }
const _hoisted_35 = { class: "text-black line-through mr-1" }
const _hoisted_36 = { class: "text-black" }
const _hoisted_37 = {
  key: 1,
  class: "text-black"
}
const _hoisted_38 = { class: "text-sm text-black leading-tight flex items-center gap-1.5 flex-wrap" }
const _hoisted_39 = ["title"]
const _hoisted_40 = { class: "text-black" }
const _hoisted_41 = { class: "px-2 py-1.5 border-l border-r border-gray-200" }
const _hoisted_42 = {
  key: 0,
  class: "flex justify-center gap-3"
}
const _hoisted_43 = { class: "text-sm text-black" }
const _hoisted_44 = { class: "text-sm font-bold text-black" }
const _hoisted_45 = {
  key: 1,
  class: "block text-center text-sm font-medium text-black"
}
const _hoisted_46 = { class: "px-2 py-1.5 whitespace-nowrap text-center border-r border-gray-200" }
const _hoisted_47 = { class: "text-sm font-semibold text-black" }
const _hoisted_48 = { class: "px-2 py-1.5 whitespace-nowrap text-center border-r border-gray-200" }
const _hoisted_49 = { class: "text-sm font-semibold text-black" }
const _hoisted_50 = { class: "px-2 py-1.5 whitespace-nowrap text-center" }
const _hoisted_51 = { class: "text-sm text-black font-medium" }
const _hoisted_52 = {
  key: 0,
  class: "px-2 py-1.5 whitespace-nowrap border-l border-gray-200 text-center"
}
const _hoisted_53 = ["checked", "onChange"]
const _hoisted_54 = { class: "block lg:hidden space-y-2" }
const _hoisted_55 = { class: "bg-gray-100 border-t-2 border-gray-300 rounded-md px-3 py-2" }
const _hoisted_56 = { class: "flex flex-wrap items-center justify-between gap-1" }
const _hoisted_57 = { class: "text-sm font-bold text-black uppercase" }
const _hoisted_58 = { class: "text-sm font-semibold text-blue-700 bg-blue-100 px-2 py-0.5 rounded" }
const _hoisted_59 = { class: "bg-white border border-gray-200 rounded-md overflow-hidden" }
const _hoisted_60 = { class: "px-3 py-1 bg-blue-50 border-b border-blue-200 min-[601px]:py-2" }
const _hoisted_61 = { class: "flex items-start justify-between gap-2" }
const _hoisted_62 = { class: "min-w-0 break-words text-sm py-1 font-bold text-blue-700 leading-tight min-[601px]:py-2" }
const _hoisted_63 = { class: "text-black" }
const _hoisted_64 = ["checked", "aria-label", "onChange"]
const _hoisted_65 = { class: "text-sm text-black leading-tight pb-1" }
const _hoisted_66 = { class: "py-2 pr-3 pl-0 min-[601px]:p-3 hover:bg-blue-50/30 transition-colors" }
const _hoisted_67 = { class: "flex gap-3" }
const _hoisted_68 = { class: "flex-shrink-0" }
const _hoisted_69 = { class: "w-28 h-36 min-[360px]:w-32 min-[360px]:h-44 min-[601px]:w-40 flex items-center justify-center bg-gray-50 rounded border border-gray-200 overflow-hidden" }
const _hoisted_70 = ["src", "alt", "onClick"]
const _hoisted_71 = {
  key: 1,
  class: "fas fa-tshirt text-black text-lg"
}
const _hoisted_72 = { class: "flex-1 min-w-0" }
const _hoisted_73 = { class: "text-sm text-black mt-0.5 mb-2 flex items-center gap-1.5 flex-wrap" }
const _hoisted_74 = ["title"]
const _hoisted_75 = { class: "mb-2" }
const _hoisted_76 = {
  key: 0,
  class: "mb-2 flex flex-wrap justify-start gap-x-3 gap-y-1"
}
const _hoisted_77 = { class: "text-sm text-black" }
const _hoisted_78 = { class: "text-sm font-bold text-black" }
const _hoisted_79 = { class: "text-sm text-black" }
const _hoisted_80 = { class: "font-bold" }
const _hoisted_81 = { class: "grid grid-cols-2 gap-2 text-sm text-black" }
const _hoisted_82 = { class: "min-w-0 break-words" }
const _hoisted_83 = { class: "flex flex-col items-start gap-0.5 font-bold" }
const _hoisted_84 = {
  key: 0,
  class: "line-through"
}
const _hoisted_85 = { class: "min-w-0 break-words" }
const _hoisted_86 = { class: "font-bold" }
const _hoisted_87 = {
  key: 3,
  class: "text-sm text-black py-4 mb-6"
}
const _hoisted_88 = {
  key: 4,
  class: "grid grid-cols-1 md:grid-cols-2 gap-3 mb-3 mt-4"
}
const _hoisted_89 = { class: "bg-gray-50 p-2 rounded text-sm" }
const _hoisted_90 = { class: "space-y-1" }
const _hoisted_91 = { class: "flex justify-between" }
const _hoisted_92 = { class: "text-black" }
const _hoisted_93 = { class: "text-black" }
const _hoisted_94 = {
  key: 0,
  class: "flex justify-between"
}
const _hoisted_95 = { class: "text-black" }
const _hoisted_96 = {
  key: 1,
  class: "flex justify-between"
}
const _hoisted_97 = { class: "text-black" }
const _hoisted_98 = {
  key: 2,
  class: "flex justify-between"
}
const _hoisted_99 = { class: "text-black" }
const _hoisted_100 = { class: "text-black" }
const _hoisted_101 = {
  key: 3,
  class: "flex justify-between"
}
const _hoisted_102 = { class: "text-black" }
const _hoisted_103 = { class: "bg-gray-50 p-2 rounded text-sm" }
const _hoisted_104 = { class: "space-y-1" }
const _hoisted_105 = { class: "flex justify-between" }
const _hoisted_106 = { class: "text-black" }
const _hoisted_107 = { class: "flex justify-between" }
const _hoisted_108 = { class: "text-black" }
const _hoisted_109 = { class: "flex justify-between" }
const _hoisted_110 = { class: "text-black" }
const _hoisted_111 = {
  key: 5,
  class: "mb-4"
}
const _hoisted_112 = { class: "bg-white border border-gray-200 rounded-lg overflow-hidden" }
const _hoisted_113 = { class: "overflow-x-auto" }
const _hoisted_114 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_115 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_116 = { class: "px-3 py-2 text-sm text-black" }
const _hoisted_117 = { class: "px-3 py-2 text-sm text-black" }
const _hoisted_118 = { class: "px-3 py-2 text-sm text-black" }
const _hoisted_119 = { class: "px-3 py-2 text-sm text-black" }
const _hoisted_120 = { class: "px-3 py-2 text-sm text-red-600 font-medium" }
const _hoisted_121 = { key: 0 }
const _hoisted_122 = { class: "px-3 py-2 text-sm text-black" }
const _hoisted_123 = { class: "px-3 py-2 text-sm text-black" }
const _hoisted_124 = { class: "px-3 py-2 text-sm text-black" }
const _hoisted_125 = { class: "px-3 py-2 text-sm text-black" }
const _hoisted_126 = { class: "px-3 py-2 text-sm text-red-600 font-medium" }
const _hoisted_127 = { key: 0 }
const _hoisted_128 = {
  key: 6,
  class: "flex gap-4 mt-4"
}
const _hoisted_129 = ["disabled", "aria-busy"]
const _hoisted_130 = {
  key: 0,
  class: "fas fa-spinner fa-spin",
  "aria-hidden": "true"
}
const _hoisted_131 = {
  key: 7,
  class: "mt-6"
}
const _hoisted_132 = {
  key: 0,
  class: "mb-3 rounded-md border border-amber-200 bg-amber-50 p-3 text-sm text-amber-900",
  role: "status"
}
const _hoisted_133 = { class: "hidden lg:block overflow-x-auto rounded border border-gray-200" }
const _hoisted_134 = { class: "min-w-full divide-y divide-gray-100" }
const _hoisted_135 = { class: "bg-white divide-y divide-gray-100" }
const _hoisted_136 = { class: "px-2 py-1.5" }
const _hoisted_137 = { class: "flex items-start gap-2" }
const _hoisted_138 = { class: "w-32 h-32 flex-shrink-0 flex items-center justify-center bg-gray-50 rounded border border-gray-200 overflow-hidden" }
const _hoisted_139 = ["src", "alt", "onClick"]
const _hoisted_140 = {
  key: 1,
  class: "fas fa-tshirt text-black text-lg"
}
const _hoisted_141 = { class: "flex-1 min-w-0" }
const _hoisted_142 = { class: "text-sm text-black leading-tight mb-0.5" }
const _hoisted_143 = { class: "text-black" }
const _hoisted_144 = { class: "text-sm text-black leading-tight mb-0.5" }
const _hoisted_145 = { class: "text-black" }
const _hoisted_146 = { class: "text-sm text-black leading-tight mb-0.5" }
const _hoisted_147 = { class: "text-black line-through mr-1" }
const _hoisted_148 = { class: "text-black" }
const _hoisted_149 = {
  key: 1,
  class: "text-black"
}
const _hoisted_150 = { class: "text-sm text-black leading-tight flex items-center gap-1.5 flex-wrap" }
const _hoisted_151 = ["title"]
const _hoisted_152 = { class: "text-black" }
const _hoisted_153 = { class: "px-2 py-1.5 border-l border-r border-gray-200" }
const _hoisted_154 = {
  key: 0,
  class: "flex justify-center gap-3"
}
const _hoisted_155 = { class: "text-sm text-black" }
const _hoisted_156 = { class: "text-sm font-bold text-black" }
const _hoisted_157 = {
  key: 1,
  class: "block text-center text-sm font-medium text-black"
}
const _hoisted_158 = { class: "px-2 py-1.5 whitespace-nowrap text-center border-r border-gray-200" }
const _hoisted_159 = { class: "text-sm font-semibold text-black" }
const _hoisted_160 = { class: "px-2 py-1.5 whitespace-nowrap text-center border-r border-gray-200" }
const _hoisted_161 = { class: "text-sm font-semibold text-black" }
const _hoisted_162 = { class: "px-2 py-1.5 whitespace-nowrap text-center" }
const _hoisted_163 = { class: "text-sm text-black font-medium" }
const _hoisted_164 = { class: "px-2 py-1.5 whitespace-nowrap border-l border-gray-200 text-center" }
const _hoisted_165 = ["checked", "onChange"]
const _hoisted_166 = {
  key: 1,
  class: "block text-xs text-indigo-700"
}
const _hoisted_167 = { class: "block lg:hidden space-y-2" }
const _hoisted_168 = { class: "bg-red-50 border border-red-200 rounded-md overflow-hidden" }
const _hoisted_169 = { class: "px-3 py-1 bg-red-100 border-b border-red-200 min-[601px]:py-2" }
const _hoisted_170 = { class: "flex items-start justify-between gap-2" }
const _hoisted_171 = { class: "min-w-0 break-words text-[11px] py-1 font-bold text-red-700 leading-tight min-[601px]:py-2" }
const _hoisted_172 = { class: "text-black" }
const _hoisted_173 = ["checked", "aria-label", "onChange"]
const _hoisted_174 = { class: "text-sm text-black leading-tight pb-1" }
const _hoisted_175 = {
  key: 0,
  class: "block text-sm text-indigo-700 py-2"
}
const _hoisted_176 = { class: "py-2 pr-3 pl-0 min-[601px]:p-3 hover:bg-red-100 transition-colors" }
const _hoisted_177 = { class: "flex gap-3" }
const _hoisted_178 = { class: "w-28 h-36 min-[360px]:w-32 min-[360px]:h-44 min-[601px]:w-40 flex-shrink-0 flex items-center justify-center bg-gray-50 rounded border border-gray-200 overflow-hidden" }
const _hoisted_179 = ["src", "alt", "onClick"]
const _hoisted_180 = {
  key: 1,
  class: "fas fa-tshirt text-red-300 text-lg"
}
const _hoisted_181 = { class: "flex-1 min-w-0" }
const _hoisted_182 = { class: "text-sm text-black mt-0.5 mb-2 flex items-center gap-1.5 flex-wrap" }
const _hoisted_183 = ["title"]
const _hoisted_184 = { class: "mb-2" }
const _hoisted_185 = {
  key: 0,
  class: "mb-2 flex flex-wrap justify-start gap-x-3 gap-y-1"
}
const _hoisted_186 = { class: "text-sm text-black" }
const _hoisted_187 = { class: "text-sm font-bold text-black" }
const _hoisted_188 = { class: "text-sm text-black" }
const _hoisted_189 = { class: "font-medium" }
const _hoisted_190 = { class: "grid grid-cols-2 gap-2 text-sm text-black" }
const _hoisted_191 = { class: "min-w-0 break-words" }
const _hoisted_192 = { class: "flex flex-col items-start gap-0.5 font-semibold" }
const _hoisted_193 = {
  key: 0,
  class: "line-through font-normal"
}
const _hoisted_194 = { class: "min-w-0 break-words" }
const _hoisted_195 = { class: "font-semibold" }
const _hoisted_196 = { class: "grid grid-cols-1 md:grid-cols-2 gap-3 mb-3 mt-4" }
const _hoisted_197 = { class: "bg-gray-50 p-2 rounded text-sm" }
const _hoisted_198 = { class: "space-y-1" }
const _hoisted_199 = { class: "flex justify-between" }
const _hoisted_200 = { class: "text-black" }
const _hoisted_201 = {
  key: 0,
  class: "flex justify-between"
}
const _hoisted_202 = { class: "text-black" }
const _hoisted_203 = { class: "text-black" }
const _hoisted_204 = {
  key: 1,
  class: "flex justify-between"
}
const _hoisted_205 = { class: "text-black" }
const _hoisted_206 = { class: "bg-gray-50 p-2 rounded text-sm" }
const _hoisted_207 = { class: "space-y-1" }
const _hoisted_208 = { class: "flex justify-between" }
const _hoisted_209 = { class: "text-black" }
const _hoisted_210 = { class: "flex justify-between" }
const _hoisted_211 = { class: "text-black" }
const _hoisted_212 = { class: "mt-3" }
const _hoisted_213 = ["disabled", "title"]
const _hoisted_214 = ["disabled"]
const _hoisted_215 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_216 = { class: "flex flex-wrap justify-between items-center gap-2 mb-3" }
const _hoisted_217 = { class: "font-semibold text-black" }
const _hoisted_218 = { class: "flex w-full flex-wrap items-center justify-between gap-2 sm:w-auto sm:justify-end" }
const _hoisted_219 = { class: "text-sm font-medium text-black" }
const _hoisted_220 = ["onClick", "disabled"]
const _hoisted_221 = { class: "hidden overflow-x-auto lg:block" }
const _hoisted_222 = { class: "min-w-full text-sm border-collapse" }
const _hoisted_223 = { class: "bg-gray-50" }
const _hoisted_224 = ["value"]
const _hoisted_225 = { class: "border px-2 py-1" }
const _hoisted_226 = ["value"]
const _hoisted_227 = ["onUpdate:modelValue", "onInput", "max"]
const _hoisted_228 = { class: "border px-2 py-1" }
const _hoisted_229 = ["onUpdate:modelValue", "onInput", "max", "readonly"]
const _hoisted_230 = { class: "space-y-3 lg:hidden" }
const _hoisted_231 = { class: "mb-2 font-semibold text-black" }
const _hoisted_232 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_233 = { class: "block min-w-0" }
const _hoisted_234 = ["value"]
const _hoisted_235 = { class: "block min-w-0" }
const _hoisted_236 = ["onUpdate:modelValue", "onInput", "max"]
const _hoisted_237 = { class: "grid grid-cols-1 gap-3 rounded-lg border border-gray-200 p-3 sm:grid-cols-2" }
const _hoisted_238 = { class: "block min-w-0" }
const _hoisted_239 = ["value"]
const _hoisted_240 = { class: "block min-w-0" }
const _hoisted_241 = ["onUpdate:modelValue", "onInput", "max", "readonly"]
const _hoisted_242 = {
  key: 0,
  class: "mt-2 text-red-600 text-sm"
}
const _hoisted_243 = {
  key: 1,
  class: "text-center py-4 text-black"
}
const _hoisted_244 = ["disabled"]
const _hoisted_245 = ["disabled", "aria-busy"]
const _hoisted_246 = {
  key: 0,
  class: "fas fa-spinner fa-spin",
  "aria-hidden": "true"
}
const _hoisted_247 = {
  key: 0,
  class: "fixed bottom-[77px] left-3 right-3 z-[900] flex items-center justify-between gap-3 rounded-xl border border-red-200 bg-white p-3 shadow-xl md:bottom-6 md:left-auto md:right-6 md:w-[420px]"
}
const _hoisted_248 = { class: "min-w-0" }
const _hoisted_249 = { class: "text-sm font-semibold text-black" }
const _hoisted_250 = ["disabled", "aria-busy"]
const _hoisted_251 = { class: "flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center" }
const _hoisted_252 = { class: "my-20 inline-block w-full text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl max-h-[90vh] overflow-hidden flex flex-col max-w-md p-6" }
const _hoisted_253 = { class: "flex items-center justify-between mb-4 flex-shrink-0" }
const _hoisted_254 = { class: "text-lg font-medium text-black" }
const _hoisted_255 = { class: "mb-4 flex-1 flex items-center justify-center" }
const _hoisted_256 = ["src", "alt"]

import {
  computed,
  inject,
  onMounted,
  onUnmounted,
  ref,
  watch,
  type ComputedRef,
} from "vue";
import { ConfirmModal, DataCard, ModalComp } from "@/components";
import { useNotification } from "@/composables/useNotification";
import type {
  OrderProduct,
  OrderSummaryData,
  OrderDetailResponse,
  LigneDiviser,
} from "@/types";
import {
  mapToProducts,
  mapToProductsRupture,
  mapToOrderSummary,
  getReplacementMessage,
} from "@/utils/orderMapper";
import { getColorSwatchStyle } from "@/utils/colorFamilies";
import {
  isEtranger as checkIsEtranger,
  calculateTVARate,
} from "@/utils/tvaUtils";
import { actionReactive, actionDiviser } from "@/api/orders";
import { useAuthStore } from "@/stores/auth";
import { getProductPhotosBatch } from "@/api/shooting";
import { getApiBaseUrl, getProductImageUrl } from "@/config/api";
import OrderReplacements from "./OrderReplacements.vue";

// Props
interface Props {
  orderId: number;
  loading?: boolean;
  class?: string;
  collapsible?: boolean;
  disableAction?: boolean;
}

interface ProductGroup {
  referenceBase: string;
  products: OrderProduct[];
  totalPieces: number;
}

interface AdminCommentaire {
  id_commande_commentaire: number;
  prenom: string | null;
  commentaire: string;
  date_creation: string;
  canDelete?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderDetailsSection',
  props: {
    orderId: {},
    loading: { type: Boolean },
    class: {},
    collapsible: { type: Boolean, default: false },
    disableAction: { type: Boolean, default: false }
  },
  emits: ["collapsed", "replacementConfirmation"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isDesktop = ref(
  typeof window !== "undefined" ? window.innerWidth > 600 : false,
);

const isCollapsed = ref(
  typeof window !== "undefined" ? window.innerWidth <= 600 : true,
);

const updateViewportState = () => {
  if (typeof window === "undefined") return;
  isDesktop.value = window.innerWidth > 600;
};

// Une fois l'animation d'ouverture terminée, on retire le plafond de hauteur
// (max-h-none) pour éviter que les grosses commandes soient tronquées par
// overflow-hidden. À la fermeture, on rétablit le plafond pour animer.
const isExpanded = ref(
  typeof window !== "undefined" ? window.innerWidth > 600 : false,
);

const toggleCollapse = () => {
  if (!props.collapsible) return;
  isCollapsed.value = !isCollapsed.value;
  if (isCollapsed.value) {
    // On replafonne immédiatement pour pouvoir animer la fermeture
    isExpanded.value = false;
  }
  emit("collapsed", isCollapsed.value);
};

const onContentTransitionEnd = (event: TransitionEvent) => {
  // Ne réagir qu'à la fin de la transition de hauteur du conteneur lui-même
  if (event.propertyName !== "max-height") return;
  if (event.target !== event.currentTarget) return;
  if (!isCollapsed.value) {
    isExpanded.value = true;
  }
};

// Récupérer les données depuis le parent via inject
const orderDetailDataInjected = inject<
  ComputedRef<{ value: OrderDetailResponse | null }>
>(
  "orderDetailData",
  computed(() => ({ value: null })),
);

// Simplifier l'accès aux données
const orderDetailData = computed(() => orderDetailDataInjected.value.value);

const orderDetailsTitle = computed(() => {
  const groupName = orderDetailData.value?.id_commande_groupe_name;

  if (groupName) return `Détails de la commande ${groupName}`;
  return "Détails de la commande";
});

onMounted(() => {
  updateViewportState();
  window.addEventListener("resize", updateViewportState);
});

onUnmounted(() => {
  if (typeof window === "undefined") return;
  window.removeEventListener("resize", updateViewportState);
});

// Injecter la fonction de rechargement depuis le parent
const reloadOrderData = inject<(() => Promise<void>) | undefined>(
  "reloadOrderData",
  undefined,
);

// reloadOrderData sera utilisé si disponible, sinon fallback sur window.location.reload()

// État pour les produits sélectionnés (checkboxes) - produits actifs
const selectedProducts = ref<number[]>([]);

// État pour les produits en rupture sélectionnés (checkboxes)
const selectedProductsRupture = ref<number[]>([]);
const replacementPanel = ref<{ open: () => Promise<void> } | null>(null);
const replacedLineIds = ref<number[]>([]);
const canProposeReplacement = computed(() => Boolean(orderDetailData.value && (authStore.isImpersonating || Number(orderDetailData.value.statut) === 1)));
const replacementUnavailableReason = computed(() => {
  if (!orderDetailData.value || canProposeReplacement.value) return '';
  if (Number(orderDetailData.value.statut) === 7) return 'Cette commande est déjà prête pour le pickup des colis. Seul un administrateur peut proposer un remplacement à ce stade.';
  return 'Le vendeur peut proposer un remplacement uniquement avant la confirmation de la commande. Contactez le SAV pour vérifier la situation de cette commande.';
});
const onReplacementChanged = async () => {
  selectedProductsRupture.value = [];
  await reloadOrderData?.();
};

// Notifications
const { success, error } = useNotification();

// États pour les modals de confirmation
const showReactiveModal = ref(false);
const showDiviserModal = ref(false);
const dividing = ref(false);

// Modal pour l'image agrandie
const showImageModal = ref(false);
const selectedImageUrl = ref<string>("");
const selectedImageAlt = ref<string>("");

// Cache des catégories pour éviter les appels répétés

// Les catégories viennent maintenant directement du backend !
// Plus besoin d'enrichissement complexe

// Données mappées depuis l'API - produits actifs
// Données mappées depuis l'API (base)
const rawProducts = computed<OrderProduct[]>(() => {
  if (!orderDetailData.value) return [];
  return mapToProducts(orderDetailData.value);
});

const products = computed<OrderProduct[]>(() => {
  if (!orderDetailData.value) return [];
  return mapToProducts(orderDetailData.value).sort((a, b) => {
    // Trier par catégorie (ordre alphabétique)
    const catA = a.categorie || "";
    const catB = b.categorie || "";
    return catA.localeCompare(catB);
  });
});

// Grouper les produits par reference_base
const productGroups = computed<ProductGroup[]>(() => {
  const grouped = new Map<string, OrderProduct[]>();

  for (const product of products.value) {
    const base = product.referenceBase || product.reference || "unknown";
    if (!grouped.has(base)) {
      grouped.set(base, []);
    }
    grouped.get(base)!.push(product);
  }

  return Array.from(grouped.entries()).map(([referenceBase, prods]) => ({
    referenceBase,
    products: prods,
    totalPieces: prods.reduce((sum, p) => sum + (p.quantite_total || 0), 0),
  }));
});

// Données mappées depuis l'API - produits en rupture
const rawProductsRupture = computed<OrderProduct[]>(() => {
  if (!orderDetailData.value) return [];
  return mapToProductsRupture(orderDetailData.value);
});

// Produits en rupture avec catégories venant directement du backend
const productsRupture = computed<OrderProduct[]>(() => {
  if (!orderDetailData.value) return [];
  return mapToProductsRupture(orderDetailData.value).sort((a, b) => {
    // Trier par catégorie (ordre alphabétique)
    const catA = a.categorie || "";
    const catB = b.categorie || "";
    return catA.localeCompare(catB);
  });
});

const orderSummary = computed<OrderSummaryData | null>(() => {
  if (!orderDetailData.value) return null;
  return mapToOrderSummary(orderDetailData.value);
});

const replacementMessage = computed<string | null>(() => {
  if (!orderDetailData.value) return null;
  return getReplacementMessage(orderDetailData.value);
});

const remises = computed(() => {
  if (!orderDetailData.value) return null;
  return orderDetailData.value.remises || null;
});

const remisesCommandes = computed(() => {
  if (!remises.value) return [];
  return remises.value.filter((r) => !r.isFraisPort);
});

const remisesFraisPort = computed(() => {
  if (!remises.value) return [];
  return remises.value.filter((r) => r.isFraisPort);
});

// Vérifier si on peut modifier la commande
// Ancien système: buttonRuptureDiviser = (statut == "1") || (admin && disable_action)
const canMarkRupture = computed(() => {
  if (!orderDetailData.value) return false;
  if (orderDetailData.value.statut === 1) return true;
  // Un admin (impersonation EFP) peut toujours toucher rupture / diviser
  return authStore.isImpersonating && props.disableAction === true;
});

// Les lignes proposées sont verrouillées individuellement via replacedLineIds.
const canReactivate = computed(() => canMarkRupture.value);
const reactivableSelection = computed(() => selectedProductsRupture.value.filter(id =>
  productsRupture.value.some(product => product.id === id) && !replacedLineIds.value.includes(id),
));

// Calculs pour les prix avec réduction
const montantTotal = computed(() => orderDetailData.value?.montantTotal || 0);
const montantCA = computed(() => orderDetailData.value?.montantCA || 0);
const montantApresRemise = computed(
  () =>
    orderDetailData.value?.montantApresRemise ||
    orderDetailData.value?.montantTotal ||
    0,
);

// Déterminer si la commande est avant 2026 (comme dans l'ancien PHP)
const yearBefore2026 = computed(() => {
  const date =
    orderDetailData.value?.dateCommande || orderDetailData.value?.dateCreation;
  if (!date) return true;
  return new Date(date).getFullYear() < 2026;
});

// PHP: if (($yearBefore2026 && $commandeObj->montantTotal != $commandeObj->montantApresRemise) || (!$yearBefore2026 && ($commandeObj->montantCA != $commandeObj->montantTotal)))

const hasReduction = computed(() => {
  if (yearBefore2026.value) {
    return montantTotal.value !== montantApresRemise.value;
  } else {
    const effectiveMontantCA = montantCA.value
      ? montantCA.value
      : montantApresRemise.value;
    return effectiveMontantCA !== montantTotal.value;
  }
});

// Montant après remise pour affichage (comme PHP: $commandeObj->montantCA?$commandeObj->montantCA:$commandeObj->montantApresRemise)
const montantApresRemiseDisplay = computed(() =>
  montantCA.value ? montantCA.value : montantApresRemise.value,
);

// Remise HT (comme PHP: $commandeObj->montantTotal - ($commandeObj->montantCA?$commandeObj->montantCA:$commandeObj->montantApresRemise))
const reductionAmount = computed(
  () => montantTotal.value - montantApresRemiseDisplay.value,
);

// Vérifier si le client est étranger (ne paye pas la TVA)
const isEtranger = computed(() => {
  if (!orderDetailData.value) return false;
  return checkIsEtranger(orderDetailData.value);
});

// Calculer le taux de TVA selon la date de la commande
const tvaRate = computed(() => {
  if (!orderDetailData.value) return 0.2;
  return calculateTVARate(
    orderDetailData.value.dateCommande || orderDetailData.value.dateCreation,
  );
});

//  PHP: ($commandeObj->montantCA?$commandeObj->montantCA:$commandeObj->montantApresRemise) * $autoTva
const tvaAmount = computed(() => {
  if (isEtranger.value) return 0;
  return montantApresRemiseDisplay.value * tvaRate.value;
});

const totalTTC = computed(() => {
  if (isEtranger.value) return montantApresRemiseDisplay.value;
  return montantApresRemiseDisplay.value * (1 + tvaRate.value);
});

// ------------------ Images: charger depuis uploads comme listproduit ------------------
const authStore = useAuthStore();
const isAdmin = computed(() => authStore.isImpersonating);

// ------------------ Commentaires admin ------------------
const adminCommentaires = ref<AdminCommentaire[]>([]);
const newAdminComment = ref("");
const savingAdminComment = ref(false);
const showDeleteCommentModal = ref(false);
const commentToDelete = ref<number | null>(null);

const unescapeComment = (value: string): string => {
  if (!value) return value;
  return value.replace(/\\(['"\\])/g, "$1");
};

const formatCommentDate = (value: string): string => {
  if (!value) return "";
  const d = new Date(value);
  if (isNaN(d.getTime())) return value;
  return d.toLocaleString("fr-FR");
};

const adminCommentApi = async (path: string, body: unknown): Promise<unknown> => {
  const response = await fetch(`${getApiBaseUrl()}/api/admin-efp/${path}`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return response.json();
};

const loadAdminCommentaires = async () => {
  if (!isAdmin.value || !props.orderId) return;
  try {
    const data = (await adminCommentApi("ruptures/commentaires/get", {
      idCommande: props.orderId,
    })) as AdminCommentaire[] | null;
    adminCommentaires.value = Array.isArray(data)
      ? data.map((c) => ({ ...c, commentaire: unescapeComment(c.commentaire) }))
      : [];
  } catch (e) {
    console.error("Erreur lors du chargement des commentaires admin:", e);
  }
};

const saveAdminCommentaire = async () => {
  const text = newAdminComment.value.trim();
  if (!text || savingAdminComment.value) return;
  savingAdminComment.value = true;
  try {
    const idCommandeName =
      orderDetailData.value?.id_commande_name ?? String(props.orderId);
    const inserted = (await adminCommentApi("ruptures/commentaires/save", {
      idCommande: props.orderId,
      idCommandeName,
      commentaire: text,
    })) as AdminCommentaire | null;
    if (inserted) {
      adminCommentaires.value.push({
        ...inserted,
        commentaire: unescapeComment(inserted.commentaire),
      });
      newAdminComment.value = "";
    }
  } catch (e) {
    error("Erreur lors de l'enregistrement du commentaire");
    console.error(e);
  } finally {
    savingAdminComment.value = false;
  }
};

const askDeleteAdminCommentaire = (idCommentaire: number) => {
  commentToDelete.value = idCommentaire;
  showDeleteCommentModal.value = true;
};

const cancelDeleteAdminCommentaire = () => {
  showDeleteCommentModal.value = false;
  commentToDelete.value = null;
};

const confirmDeleteAdminCommentaire = async () => {
  const idCommentaire = commentToDelete.value;
  showDeleteCommentModal.value = false;
  commentToDelete.value = null;
  if (idCommentaire == null) return;
  try {
    await adminCommentApi("ruptures/commentaires/delete", {
      idCommande: props.orderId,
      idCommentaire,
    });
    adminCommentaires.value = adminCommentaires.value.filter(
      (c) => c.id_commande_commentaire !== idCommentaire,
    );
  } catch (e) {
    error("Erreur lors de la suppression du commentaire");
    console.error(e);
  }
};

watch(
  () => [isAdmin.value, props.orderId] as const,
  () => {
    if (isAdmin.value && props.orderId) {
      loadAdminCommentaires();
    } else {
      adminCommentaires.value = [];
    }
  },
  { immediate: true },
);

// Batch load product photos using the batch API
const batchLoadProductPhotos = async (productIds: number[]): Promise<void> => {
  if (productIds.length === 0) return;

  try {
    // Appeler l'API batch (retourne { success, photosByProduct })
    const { success, photosByProduct } = await getProductPhotosBatch(
      productIds,
    );

    if (!success || !photosByProduct) {
      return;
    }

    // Mettre à jour le cache et imageUrls avec les résultats
    const idVendeur = authStore.user?.id;
    productIds.forEach((pid) => {
      const photos = photosByProduct[pid];
      const first =
        Array.isArray(photos) && photos.length > 0 ? photos[0] : undefined;

      const absoluteUrl = first
        ? getProductImageUrl(first)
        : idVendeur
          ? getProductImageUrl(
              `/uploads/products/${idVendeur}/Produits/accueil/${pid}-c.jpg`,
            )
          : undefined;

      if (absoluteUrl) {
        imageCache.set(pid, absoluteUrl);
        imageUrls.value[pid] = absoluteUrl;
      }
    });
  } catch (error) {
    console.error("Erreur lors du chargement batch des photos:", error);
    // Pas de fallback : en cas d'erreur, on n'affiche rien
  }
};

// Cache URLs by productId (non‑reactive, for avoiding duplicate fetches)
const imageCache = new Map<number, string>();

// Reactive store to ensure the template updates when a URL is resolved
const imageUrls = ref<Record<number, string>>({});

const resolveImageUrl = (p: OrderProduct): string | undefined => {
  // Already present from API or cache
  if ((p as any).imageUrl) return (p as any).imageUrl || undefined;
  const pid = p.productId;
  if (!pid) return undefined;

  // Retourner depuis le cache (rempli par le batch)
  if (imageCache.has(pid)) return imageCache.get(pid);
  if (imageUrls.value[pid]) return imageUrls.value[pid];

  return undefined;
};

// Public getter used in template (returns cached URL from batch)
const getImageUrlForProduct = (p: OrderProduct): string | undefined => {
  const pid = p.productId;
  if (!pid) return undefined;

  // Lire depuis le store réactif (rempli par le batch)
  if (imageUrls.value[pid]) return imageUrls.value[pid];

  // Fallback au cache
  const cached = imageCache.get(pid);
  if (cached) return cached;

  // Pas de fallback : si pas de photo, on retourne undefined
  return undefined;
};

const replacementProducts = computed(() => productsRupture.value.map(product => ({
  ...product,
  imageUrl: product.imageUrl || getImageUrlForProduct(product) || null,
})));

// Batch load images when product lists change
watch(
  products,
  async (list) => {
    // Récupérer tous les IDs de produits qui n'ont pas encore d'image en cache
    const productIds = list
      .map((p) => p.productId)
      .filter(
        (pid): pid is number => pid !== undefined && !imageCache.has(pid),
      );

    if (productIds.length > 0) {
      await batchLoadProductPhotos(productIds);
    }
  },
  { immediate: true },
);

// Batch load images pour les produits en rupture aussi
watch(
  productsRupture,
  async (list) => {
    const productIds = list
      .map((p) => p.productId)
      .filter(
        (pid): pid is number => pid !== undefined && !imageCache.has(pid),
      );

    if (productIds.length > 0) {
      await batchLoadProductPhotos(productIds);
    }
  },
  { immediate: true },
);

// Calculs pour les produits en rupture
// Montant HT avant remise de commande (somme des prixLigne sans remise de commande)
const totalRuptureHTAvantRemiseCommande = computed(() => {
  return productsRupture.value.reduce(
    (sum, p) => sum + (p.priceLineHT || p.price || 0),
    0,
  );
});

// Montant HT après remise de commande (utiliser montantRuptureHT du backend si disponible)
// Sinon, appliquer les remises en pourcentage seulement (comme l'ancien système pour corbeille)
const totalRuptureHT = computed(() => {
  // Si on a montantRuptureHT du backend, l'utiliser (déjà calculé avec remises)
  if (orderDetailData.value?.montantRuptureHT != null) {
    return orderDetailData.value.montantRuptureHT;
  }

  // Sinon, calculer depuis les produits et appliquer les remises en pourcentage seulement
  let total = totalRuptureHTAvantRemiseCommande.value;

  // Appliquer seulement les remises en pourcentage (comme l'ancien système pour corbeille)
  for (const remise of remisesCommandes.value) {
    if (remise.type === "pourcentage") {
      const pourcentage = Math.abs(
        parseFloat(remise.montant?.toString() || "0"),
      );
      total = total - (total * pourcentage) / 100;
    }
    // Les remises fixes (reduction) ne sont PAS appliquées aux produits en rupture dans l'ancien système
  }

  return parseFloat(Math.max(0, total).toFixed(2));
});

const hasReductionRupture = computed(() => {
  return (
    totalRuptureHTAvantRemiseCommande.value > 0 &&
    totalRuptureHT.value < totalRuptureHTAvantRemiseCommande.value
  );
});

const reductionAmountRupture = computed(() => {
  return totalRuptureHTAvantRemiseCommande.value - totalRuptureHT.value;
});

const tvaAmountRupture = computed(() => {
  if (isEtranger.value) return 0;
  return totalRuptureHT.value * tvaRate.value;
});

const totalRuptureTTC = computed(() => {
  if (isEtranger.value) return totalRuptureHT.value;
  return totalRuptureHT.value * (1 + tvaRate.value);
});

const totalRuptureQuantite = computed(() => {
  return productsRupture.value.reduce(
    (sum, p) => sum + (p.quantite_total || p.details || 0),
    0,
  );
});

const totalRupturePoids = computed(() => {
  return productsRupture.value.reduce(
    (sum, p) => sum + (p.weightTotal || p.weight || 0),
    0,
  );
});

// Méthodes
const formatPrice = (price: number) => {
  return price.toFixed(2);
};

const formatWeight = (weight: number) => {
  return weight.toFixed(2);
};

// Gérer les erreurs d'image
const handleImageError = (event: Event) => {
  const img = event.target as HTMLImageElement;
  img.style.display = "none";
  const parent = img.parentElement;
  if (parent) {
    const icon = document.createElement("i");
    icon.className = "fas fa-tshirt text-black text-2xl";
    parent.appendChild(icon);
  }
};

// État pour la division
const lignesADiviser = ref<LigneDiviser[]>([]);

// Toggle la sélection d'un produit (actif)
const toggleProduct = (productId: number) => {
  const index = selectedProducts.value.indexOf(productId);
  if (index > -1) {
    selectedProducts.value.splice(index, 1);
  } else {
    selectedProducts.value.push(productId);
  }
};

// Toggle la sélection d'un produit en rupture
const toggleProductRupture = (productId: number) => {
  const index = selectedProductsRupture.value.indexOf(productId);
  if (index > -1) {
    selectedProductsRupture.value.splice(index, 1);
  } else {
    selectedProductsRupture.value.push(productId);
  }
};

// Ouvrir la modal de confirmation pour la réactivation
const openReactiveModal = () => {
  if (!canReactivate.value || reactivableSelection.value.length === 0) {
    return;
  }
  showReactiveModal.value = true;
};

// Ouvrir la modal de division
const openDiviserModal = () => {
  if (dividing.value || selectedProducts.value.length === 0) {
    return;
  }

  // Initialiser les lignes à diviser
  lignesADiviser.value = selectedProducts.value
    .map((productId) => {
      const product = products.value.find((p) => p.id === productId);
      if (!product) {
        return null;
      }

      // Récupérer les quantités originales
      const quantitesOriginales: number[] = [];
      const declinaisonsLabels: string[] = [];
      let maxDeclinaisons = 0;

      if (product.declinaisons && product.quantites) {
        // Trouver la dernière déclinaison avec une quantité > 0
        let lastIndexWithQty = 0;
        for (let i = 1; i <= 12; i++) {
          const qty =
            product.quantites[`q${i}` as keyof typeof product.quantites] || 0;
          if (qty > 0) {
            lastIndexWithQty = i;
          }
        }

        // Récupérer toutes les quantités jusqu'à la dernière avec quantité > 0
        for (let i = 1; i <= lastIndexWithQty; i++) {
          const qty =
            product.quantites[`q${i}` as keyof typeof product.quantites] || 0;
          quantitesOriginales.push(qty);
          const declLabel =
            product.declinaisons[
              `d${i}_FR` as keyof typeof product.declinaisons
            ] ||
            product.declinaisons[
              `d${i}_UK` as keyof typeof product.declinaisons
            ] ||
            "";
          declinaisonsLabels.push(declLabel);
          maxDeclinaisons = i;
        }

        // Si aucune quantité trouvée, utiliser quantite_total
        if (quantitesOriginales.length === 0) {
          quantitesOriginales.push(
            product.quantite_total || product.details || 0,
          );
          declinaisonsLabels.push("");
          maxDeclinaisons = 1;
        }
      } else {
        // Si pas de déclinaisons, une seule quantité
        quantitesOriginales.push(
          product.quantite_total || product.details || 0,
        );
        declinaisonsLabels.push("");
        maxDeclinaisons = 1;
      }

      // Initialiser base_qt avec les quantités originales et qt à 0
      const base_qt = [...quantitesOriginales];
      const qt = new Array(quantitesOriginales.length).fill(0);

      // Calculer le prix unitaire
      const quantiteTotalOriginale = quantitesOriginales.reduce(
        (sum, q) => sum + q,
        0,
      );
      const prixLigneHT = product.priceLineHT || product.price || 0;
      const prixUnitaire =
        quantiteTotalOriginale > 0
          ? prixLigneHT / quantiteTotalOriginale
          : product.priceUnit || 0;

      return {
        id_ligne: product.id,
        reference: product.reference || "",
        quantitesOriginales,
        base_qt,
        qt,
        base_prixligne: prixLigneHT,
        prixligne: 0,
        prixOriginal: prixLigneHT, // Sauvegarder le prix original
        prixUnitaire, // Prix unitaire HT
        maxDeclinaisons,
        declinaisonsLabels,
      } as LigneDiviser;
    })
    .filter((l): l is LigneDiviser => l !== null);

  if (lignesADiviser.value.length === 0) {
    return;
  }

  showDiviserModal.value = true;
};

// Ouvrir la modal d'image
const openImageModal = (imageUrl: string | undefined, alt: string) => {
  if (!imageUrl) return;
  selectedImageUrl.value = imageUrl;
  selectedImageAlt.value = alt;
  showImageModal.value = true;
};

// Fermer la modal d'image
const closeImageModal = () => {
  showImageModal.value = false;
  selectedImageUrl.value = "";
  selectedImageAlt.value = "";
};

// Mettre à jour les prix lors de la modification des quantités
const roundDiviserPrice = (value: number) =>
  Math.round((value + Number.EPSILON) * 100) / 100;

const isRuptureTotale = (ligne: LigneDiviser) =>
  ligne.quantitesOriginales.every(
    (quantite, index) => ligne.qt[index] === quantite,
  );

const remplirRuptureTotale = (ligne: LigneDiviser) => {
  ligne.qt = [...ligne.quantitesOriginales];
  updateDiviserPrix(ligne);
};

const updateDiviserPrix = (ligne: LigneDiviser) => {
  // Calculer base_qt automatiquement : base_qt = quantitesOriginales - qt
  for (let i = 0; i < ligne.quantitesOriginales.length; i++) {
    const qt = ligne.qt[i] || 0;
    const original = ligne.quantitesOriginales[i] || 0;
    ligne.base_qt[i] = Math.max(0, original - qt);
  }

  // Vérifier que base_qt + qt = quantités originales
  let isValid = true;
  for (let i = 0; i < ligne.quantitesOriginales.length; i++) {
    const baseQt = ligne.base_qt[i] || 0;
    const qt = ligne.qt[i] || 0;
    const original = ligne.quantitesOriginales[i] || 0;

    if (baseQt + qt !== original) {
      isValid = false;
      ligne.error =
        "La somme des quantités doit être égale à la quantité originale";
      break;
    }
  }

  if (isValid) {
    ligne.error = undefined;

    // Calculer les prix proportionnellement
    const quantiteTotalRupture = ligne.qt.reduce((sum, q) => sum + q, 0);
    const quantiteTotalOriginale = ligne.quantitesOriginales.reduce(
      (sum, q) => sum + q,
      0,
    );

    if (quantiteTotalOriginale > 0) {
      // Utiliser le prix original pour calculer le prix unitaire
      const prixUnitaire = ligne.prixOriginal / quantiteTotalOriginale;
      ligne.prixligne = roundDiviserPrice(
        prixUnitaire * quantiteTotalRupture,
      );
      ligne.base_prixligne = roundDiviserPrice(
        ligne.prixOriginal - ligne.prixligne,
      );
    }
  }
};

// Comme dans l'ancien back-office, un administrateur peut ajuster le prix
// de la ligne en rupture. Le prix de la ligne restante est recalculé afin
// que la somme reste toujours égale au prix original.
const updateDiviserManualPrice = (ligne: LigneDiviser) => {
  if (!isAdmin.value) return;

  let prixRupture = Number(ligne.prixligne);
  if (!Number.isFinite(prixRupture)) {
    prixRupture = 0;
  }

  prixRupture = Math.min(Math.max(prixRupture, 0), ligne.prixOriginal);
  ligne.prixligne = roundDiviserPrice(prixRupture);
  ligne.base_prixligne = roundDiviserPrice(
    ligne.prixOriginal - ligne.prixligne,
  );
};

const isSinglePiecePriceAdjustment = (ligne: LigneDiviser) => {
  const originalQty = ligne.quantitesOriginales.reduce(
    (sum, qty) => sum + qty,
    0,
  );
  const ruptureQty = ligne.qt.reduce((sum, qty) => sum + qty, 0);
  return originalQty === 1 && ruptureQty === 0 && ligne.prixligne > 0;
};

const getLignesADiviserModifiees = () =>
  lignesADiviser.value.filter((ligne) => {
    const ruptureQty = ligne.qt.reduce((sum, quantite) => sum + quantite, 0);
    return ruptureQty > 0 || isSinglePiecePriceAdjustment(ligne);
  });

// Vérifier si on peut confirmer la division
const canConfirmDiviser = computed(() => {
  const lignesModifiees = getLignesADiviserModifiees();
  if (lignesModifiees.length === 0) return false;

  return lignesModifiees.every((ligne) => {
    if (ligne.error) return false;
    const quantiteTotalBase = ligne.base_qt.reduce(
      (sum, quantite) => sum + quantite,
      0,
    );
    const prixTotal = roundDiviserPrice(
      ligne.base_prixligne + ligne.prixligne,
    );
    return (
      (quantiteTotalBase === 0
        ? ligne.base_prixligne === 0
        : ligne.base_prixligne > 0) &&
      ligne.prixligne > 0 &&
      prixTotal === roundDiviserPrice(ligne.prixOriginal)
    );
  });
});

// Confirmer la division
const confirmDiviser = async () => {
  if (dividing.value || !canConfirmDiviser.value) {
    return;
  }

  dividing.value = true;
  try {
    const lignes = getLignesADiviserModifiees().map((ligne) => ({
      id_ligne: ligne.id_ligne,
      base_qt: ligne.base_qt,
      qt: ligne.qt,
      base_prixligne: ligne.base_prixligne,
      prixligne: ligne.prixligne,
    }));

    const result = await actionDiviser(props.orderId, lignes);

    if (result) {
      success("Les lignes ont été divisées avec succès");
      // Fermer la modal
      showDiviserModal.value = false;
      // Réinitialiser la sélection
      selectedProducts.value = [];
      lignesADiviser.value = [];
      // Recharger les données après un court délai pour laisser le temps de voir le toast
      setTimeout(async () => {
        if (reloadOrderData && typeof reloadOrderData === "function") {
          await reloadOrderData();
        } else {
          console.warn(
            "[OrderDetailsSection] reloadOrderData non disponible, utilisation du fallback",
          );
          window.location.reload();
        }
      }, 1500);
    } else {
      error("L'échec de l'action, merci de recommencer.");
    }
  } catch (err: unknown) {
    const errorMessage =
      err instanceof Error
        ? err.message
        : "Une erreur est survenue. Merci de réessayer.";
    error(errorMessage);
  } finally {
    dividing.value = false;
  }
};

// Confirmer la réactivation
const confirmReactive = async () => {
  if (!canReactivate.value || reactivableSelection.value.length === 0) return;
  const ids = [...reactivableSelection.value];
  showReactiveModal.value = false;

  try {
    // Appeler l'API
    const result = await actionReactive(
      props.orderId,
      ids,
    );

    if (result) {
      success("Les produits ont été réactivés avec succès");
      // Réinitialiser la sélection
      selectedProductsRupture.value = [];
      // Recharger les données après un court délai pour laisser le temps de voir le toast
      setTimeout(async () => {
        if (reloadOrderData && typeof reloadOrderData === "function") {
          await reloadOrderData();
        } else {
          // Fallback si la fonction n'est pas disponible
          window.location.reload();
        }
      }, 1500);
    } else {
      error("L'échec de l'action, merci de recommencer.");
    }
  } catch (err: unknown) {
    const errorMessage =
      err instanceof Error
        ? err.message
        : "Une erreur est survenue. Merci de réessayer.";
    error(errorMessage);
  }
};

// Affichage tailles : S / M / L au-dessus, quantités en dessous
const getProductSizeRows = (
  product: OrderProduct,
): Array<{ label: string; qty: number }> => {
  if (!product.declinaisons || !product.quantites) return [];

  const decl = product.declinaisons;
  const qty = product.quantites;
  const rows: Array<{ label: string; qty: number }> = [];

  for (let i = 1; i <= 12; i++) {
    const quantite = Number(qty[`q${i}` as keyof typeof qty] || 0);
    if (quantite <= 0) continue;
    const declLabel =
      decl[`d${i}_FR` as keyof typeof decl] ||
      decl[`d${i}_UK` as keyof typeof decl] ||
      "";
    if (!declLabel) continue;
    rows.push({ label: String(declLabel), qty: quantite });
  }

  return rows;
};

const hasOfficialColorSwatch = (product: OrderProduct): boolean =>
  Number(product.colorOfficiel) === 1;

const getOfficialColorSwatchStyle = (
  product: OrderProduct,
): Record<string, string> => {
  const name = product.colorFR || product.color || "";
  const hex = (product.colorHex || "").trim();
  if (hex.includes("-")) {
    const parts = hex
      .split("-")
      .map((part) => part.trim())
      .filter(Boolean)
      .map((part) => (part.startsWith("#") ? part : `#${part}`));
    if (parts.length >= 2) {
      const slice = 100 / parts.length;
      const stops = parts
        .map((color, i) => {
          const from = Math.round(i * slice);
          const to = Math.round((i + 1) * slice);
          return `${color} ${from}%, ${color} ${to}%`;
        })
        .join(", ");
      return { backgroundImage: `linear-gradient(90deg, ${stops})` };
    }
  }
  return getColorSwatchStyle(name, hex || null);
};

/** Pièces dans un pack (ex. 6 pour 2S 2M 2L). */
const getPackQuantity = (product: OrderProduct): number => {
  const packs = Number(product.quantite_pack || 0);
  const total = Number(product.quantite_total || product.details || 0);
  if (packs > 0 && total > 0) {
    return Math.round(total / packs);
  }
  const sizeTotal = getProductSizeRows(product).reduce(
    (sum, row) => sum + row.qty,
    0,
  );
  return sizeTotal || total || 0;
};

/** Affichage qté commandée selon le type de vente. */
const getOrderedQuantityLabel = (product: OrderProduct): string => {
  const venduPar = product.vendu_par || "couleurs";
  const nbPacks = Number(product.quantite_pack || 0);
  const total = Number(product.quantite_total || product.details || 0);
  const packSize = getPackQuantity(product);

  const formatPieces = (count: number): string =>
    count === 1 ? "1 pc" : `${count} pcs`;

  // Vendu par taille : pièces uniquement (détail dans la colonne Taille)
  if (venduPar === "tailles") {
    return formatPieces(total);
  }

  // couleurs / melangees : toujours format pack · pcs (même pack de 1)
  if (nbPacks <= 0) {
    return formatPieces(total);
  }

  const packWord = nbPacks === 1 ? "pack" : "packs";
  const pieceWord = packSize === 1 ? "pc" : "pcs";
  return `${nbPacks} ${packWord} · ${packSize} ${pieceWord}`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(DataCard), {
      title: orderDetailsTitle.value,
      icon: "fas fa-shopping-cart",
      iconBgColor: "bg-purple-100",
      iconColor: "text-purple-600",
      clickable: false,
      class: "mb-4",
      className: "max-[600px]:p-4"
    }, {
      "title-after": _withCtx(() => [
        (orderDetailData.value?.id_commande_groupe)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("span", _hoisted_1, " #" + _toDisplayString(orderDetailData.value.id_commande_groupe), 1),
              _createElementVNode("span", _hoisted_2, " #" + _toDisplayString(orderDetailData.value.id_commande_groupe), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      "header-toggle": _withCtx(() => [
        (_ctx.collapsible)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "inline-flex items-center gap-2 rounded-lg border-2 border-gray-300 bg-white px-3 py-1.5 text-sm font-semibold text-gray-700 shadow-sm transition-colors hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200 max-[600px]:h-10 max-[600px]:w-10 max-[600px]:justify-center max-[600px]:border-0 max-[600px]:p-0 max-[600px]:shadow-none",
              "aria-expanded": !isCollapsed.value,
              "aria-label": isCollapsed.value ? 'Voir les détails de la commande' : 'Masquer les détails de la commande',
              onClick: _withModifiers(toggleCollapse, ["stop"])
            }, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(isCollapsed.value ? "Voir" : "Masquer"), 1),
              _createElementVNode("i", {
                class: _normalizeClass([
            'fas text-xs transition-transform duration-200',
            isCollapsed.value ? 'fa-chevron-down' : 'fa-chevron-up',
          ])
              }, null, 2)
            ], 8, _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass([
        'transition-all duration-300 ease-in-out',
        _ctx.collapsible
          ? isCollapsed.value
            ? 'max-h-0 opacity-0 overflow-hidden'
            : isExpanded.value
              ? 'max-h-none opacity-100'
              : 'max-h-[20000px] opacity-100 overflow-hidden'
          : '',
      ]),
          onTransitionend: onContentTransitionEnd
        }, [
          (replacementMessage.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, _toDisplayString(replacementMessage.value), 1)
              ]))
            : _createCommentVNode("", true),
          (isAdmin.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "font-semibold text-sm text-blue-900 mb-2" }, [
                  _createElementVNode("i", { class: "fas fa-comment-dots mr-1" }),
                  _createTextVNode(" Commentaires ")
                ], -1)),
                (adminCommentaires.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(adminCommentaires.value, (c) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: c.id_commande_commentaire,
                          class: "bg-white border border-blue-100 rounded p-2"
                        }, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("b", null, _toDisplayString(c.prenom) + " :", 1),
                            _cache[9] || (_cache[9] = _createTextVNode()),
                            _createElementVNode("span", null, _toDisplayString(c.commentaire), 1),
                            (c.canDelete)
                              ? (_openBlock(), _createElementBlock("i", {
                                  key: 0,
                                  class: "fas fa-trash-alt text-red-500 cursor-pointer ml-1",
                                  onClick: ($event: any) => (askDeleteAdminCommentaire(c.id_commande_commentaire))
                                }, null, 8, _hoisted_10))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_11, _toDisplayString(formatCommentDate(c.date_creation)), 1)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newAdminComment).value = $event)),
                    rows: "2",
                    class: "w-full border rounded px-2 py-1 text-sm",
                    placeholder: "Ajouter un commentaire..."
                  }, null, 512), [
                    [_vModelText, newAdminComment.value]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "mt-1 bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded text-sm disabled:opacity-50",
                    disabled: savingAdminComment.value,
                    onClick: saveAdminCommentaire
                  }, " Enregistrer ", 8, _hoisted_12)
                ])
              ]))
            : _createCommentVNode("", true),
          (products.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("table", _hoisted_15, [
                    _createElementVNode("thead", _hoisted_16, [
                      _createElementVNode("tr", null, [
                        _cache[11] || (_cache[11] = _createElementVNode("th", { class: "px-2 py-1.5 text-left text-xs font-semibold text-black uppercase tracking-wider" }, " Produit ", -1)),
                        _cache[12] || (_cache[12] = _createElementVNode("th", { class: "px-2 py-1.5 text-center text-xs font-semibold text-black uppercase tracking-wider border-l border-r border-gray-200" }, " Taille ", -1)),
                        _cache[13] || (_cache[13] = _createElementVNode("th", { class: "px-2 py-1.5 text-center text-xs font-semibold text-black uppercase tracking-wider border-r border-gray-200" }, " Qté commandée ", -1)),
                        _cache[14] || (_cache[14] = _createElementVNode("th", { class: "px-2 py-1.5 text-center text-xs font-semibold text-black uppercase tracking-wider border-r border-gray-200" }, " Prix HT ", -1)),
                        _cache[15] || (_cache[15] = _createElementVNode("th", { class: "px-2 py-1.5 text-center text-xs font-semibold text-black uppercase tracking-wider" }, " Poids (kg) ", -1)),
                        (canMarkRupture.value)
                          ? (_openBlock(), _createElementBlock("th", _hoisted_17, " Rupture "))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("tbody", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productGroups.value, (group) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: group.referenceBase
                        }, [
                          _createElementVNode("tr", _hoisted_19, [
                            _createElementVNode("td", {
                              colspan: canMarkRupture.value ? 6 : 5,
                              class: "px-3 py-2"
                            }, [
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("span", _hoisted_22, [
                                  _cache[16] || (_cache[16] = _createElementVNode("i", { class: "fas fa-layer-group mr-2 text-blue-600" }, null, -1)),
                                  _createTextVNode(" Réf. Base : " + _toDisplayString(group.referenceBase), 1)
                                ]),
                                _createElementVNode("span", _hoisted_23, " Total pièces : " + _toDisplayString(group.totalPieces), 1)
                              ])
                            ], 8, _hoisted_20)
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.products, (product) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: product.id,
                              class: "hover:bg-blue-50/30 transition-colors"
                            }, [
                              _createElementVNode("td", _hoisted_24, [
                                _createElementVNode("div", _hoisted_25, [
                                  _createElementVNode("div", _hoisted_26, [
                                    (getImageUrlForProduct(product))
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: getImageUrlForProduct(product),
                                          alt: product.reference,
                                          class: "w-full h-full object-cover cursor-pointer hover:opacity-90 transition-opacity",
                                          loading: "lazy",
                                          onError: handleImageError,
                                          onClick: ($event: any) => (
                          openImageModal(
                            getImageUrlForProduct(product),
                            product.reference,
                          )
                        )
                                        }, null, 40, _hoisted_27))
                                      : (_openBlock(), _createElementBlock("i", _hoisted_28))
                                  ]),
                                  _createElementVNode("div", _hoisted_29, [
                                    _createElementVNode("p", _hoisted_30, [
                                      _cache[17] || (_cache[17] = _createElementVNode("span", { class: "font-medium text-black" }, "Réf: ", -1)),
                                      _createElementVNode("span", _hoisted_31, _toDisplayString(product.reference || "-"), 1)
                                    ]),
                                    _createElementVNode("p", _hoisted_32, [
                                      _cache[18] || (_cache[18] = _createElementVNode("span", { class: "font-medium text-black" }, "Catégorie: ", -1)),
                                      _createElementVNode("span", _hoisted_33, _toDisplayString(product.categorie || "-"), 1)
                                    ]),
                                    _createElementVNode("p", _hoisted_34, [
                                      _cache[19] || (_cache[19] = _createElementVNode("span", { class: "font-medium text-black" }, "Prix: ", -1)),
                                      (product.hasRemise && product.priceUnitNormal)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createElementVNode("span", _hoisted_35, _toDisplayString(formatPrice(product.priceUnitNormal)) + "€", 1),
                                            _createElementVNode("span", _hoisted_36, _toDisplayString(formatPrice(product.priceUnit || 0)) + "€", 1)
                                          ], 64))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(formatPrice(product.priceUnit || 0)) + "€", 1))
                                    ]),
                                    _createElementVNode("p", _hoisted_38, [
                                      _cache[20] || (_cache[20] = _createElementVNode("span", { class: "font-medium text-black" }, "Couleur: ", -1)),
                                      (hasOfficialColorSwatch(product))
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 0,
                                            class: "color-swatch-dot inline-block w-3.5 h-3.5 rounded-full flex-shrink-0",
                                            style: _normalizeStyle(getOfficialColorSwatchStyle(product)),
                                            title: product.colorFR || product.color || ''
                                          }, null, 12, _hoisted_39))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("span", _hoisted_40, _toDisplayString(product.colorFR || product.color || "-"), 1)
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("td", _hoisted_41, [
                                (getProductSizeRows(product).length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getProductSizeRows(product), (row) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: row.label,
                                          class: "flex flex-col items-center gap-0.5"
                                        }, [
                                          _createElementVNode("span", _hoisted_43, _toDisplayString(row.label), 1),
                                          _createElementVNode("span", _hoisted_44, _toDisplayString(row.qty), 1)
                                        ]))
                                      }), 128))
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_45, "—"))
                              ]),
                              _createElementVNode("td", _hoisted_46, [
                                _createElementVNode("p", _hoisted_47, _toDisplayString(getOrderedQuantityLabel(product)), 1)
                              ]),
                              _createElementVNode("td", _hoisted_48, [
                                _createElementVNode("p", _hoisted_49, _toDisplayString(formatPrice(product.priceLineHT || product.price || 0)) + "€ ", 1)
                              ]),
                              _createElementVNode("td", _hoisted_50, [
                                _createElementVNode("p", _hoisted_51, _toDisplayString(formatWeight(product.weightTotal || product.weight || 0)), 1)
                              ]),
                              (canMarkRupture.value)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_52, [
                                    _createElementVNode("input", {
                                      type: "checkbox",
                                      checked: selectedProducts.value.includes(product.id),
                                      onChange: ($event: any) => (toggleProduct(product.id)),
                                      class: "w-3.5 h-3.5 text-blue-600 bg-white border-gray-300 rounded focus:ring-1 focus:ring-blue-500 cursor-pointer"
                                    }, null, 40, _hoisted_53)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ], 64))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_54, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productGroups.value, (group) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: group.referenceBase
                    }, [
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, [
                          _createElementVNode("span", _hoisted_57, [
                            _cache[21] || (_cache[21] = _createElementVNode("i", { class: "fas fa-layer-group mr-2 text-blue-600" }, null, -1)),
                            _createTextVNode(" Réf. Base : " + _toDisplayString(group.referenceBase), 1)
                          ]),
                          _createElementVNode("span", _hoisted_58, " Total pièces : " + _toDisplayString(group.totalPieces), 1)
                        ])
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.products, (product) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: product.id
                        }, [
                          _createElementVNode("div", _hoisted_59, [
                            _createElementVNode("div", _hoisted_60, [
                              _createElementVNode("div", _hoisted_61, [
                                _createElementVNode("div", _hoisted_62, [
                                  _cache[22] || (_cache[22] = _createTextVNode(" Réf : ")),
                                  _createElementVNode("span", _hoisted_63, _toDisplayString(product.reference || "-"), 1)
                                ]),
                                (canMarkRupture.value)
                                  ? (_openBlock(), _createElementBlock("input", {
                                      key: 0,
                                      type: "checkbox",
                                      checked: selectedProducts.value.includes(product.id),
                                      "aria-label": `Sélectionner le produit ${product.reference || product.id}`,
                                      onChange: ($event: any) => (toggleProduct(product.id)),
                                      class: "w-6 h-6 mt-1 min-[601px]:mt-2 flex-shrink-0 text-blue-600 bg-white border-gray-300 rounded focus:ring-2 focus:ring-blue-500 cursor-pointer"
                                    }, null, 40, _hoisted_64))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_65, [
                                _cache[23] || (_cache[23] = _createTextVNode(" Catégorie : ")),
                                _createElementVNode("span", null, _toDisplayString(product.categorie || "-"), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_66, [
                              _createElementVNode("div", _hoisted_67, [
                                _createElementVNode("div", _hoisted_68, [
                                  _createElementVNode("div", _hoisted_69, [
                                    (getImageUrlForProduct(product))
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: getImageUrlForProduct(product),
                                          alt: product.reference,
                                          class: "w-full h-full object-contain min-[601px]:object-cover cursor-pointer hover:opacity-90 transition-opacity",
                                          loading: "lazy",
                                          onError: handleImageError,
                                          onClick: ($event: any) => (
                          openImageModal(
                            getImageUrlForProduct(product),
                            product.reference,
                          )
                        )
                                        }, null, 40, _hoisted_70))
                                      : (_openBlock(), _createElementBlock("i", _hoisted_71))
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_72, [
                                  _createElementVNode("p", _hoisted_73, [
                                    _cache[24] || (_cache[24] = _createTextVNode(" Couleur: ")),
                                    (hasOfficialColorSwatch(product))
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: "color-swatch-dot inline-block w-3.5 h-3.5 rounded-full flex-shrink-0",
                                          style: _normalizeStyle(getOfficialColorSwatchStyle(product)),
                                          title: product.colorFR || product.color || ''
                                        }, null, 12, _hoisted_74))
                                      : _createCommentVNode("", true),
                                    _createTextVNode(" " + _toDisplayString(product.colorFR || product.color || "-"), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_75, [
                                    (getProductSizeRows(product).length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getProductSizeRows(product), (row) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: row.label,
                                              class: "flex flex-col items-center gap-0.5"
                                            }, [
                                              _createElementVNode("span", _hoisted_77, _toDisplayString(row.label), 1),
                                              _createElementVNode("span", _hoisted_78, _toDisplayString(row.qty), 1)
                                            ]))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_79, [
                                      _cache[25] || (_cache[25] = _createElementVNode("div", { class: "mb-0.5" }, "Qté commandée", -1)),
                                      _createElementVNode("div", _hoisted_80, _toDisplayString(getOrderedQuantityLabel(product)), 1)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_81, [
                                    _createElementVNode("div", _hoisted_82, [
                                      _cache[26] || (_cache[26] = _createElementVNode("div", { class: "mb-0.5" }, "Prix HT:", -1)),
                                      _createElementVNode("div", _hoisted_83, [
                                        (product.hasRemise && product.priceUnitNormal)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_84, _toDisplayString(formatPrice(product.priceUnitNormal)) + "€", 1))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("span", null, _toDisplayString(formatPrice(product.priceUnit || 0)) + "€", 1)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_85, [
                                      _cache[27] || (_cache[27] = _createElementVNode("div", { class: "mb-0.5" }, "Total:", -1)),
                                      _createElementVNode("span", _hoisted_86, _toDisplayString(formatPrice(product.priceLineHT || product.price || 0)) + "€", 1)
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ], 64))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_87, " Aucun produit dans cette commande ")),
          (orderSummary.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("div", _hoisted_90, [
                    _createElementVNode("div", _hoisted_91, [
                      _createElementVNode("span", _hoisted_92, "Prix Total HT" + _toDisplayString(hasReduction.value ? " avant remise" : "") + " (€) :", 1),
                      _createElementVNode("span", _hoisted_93, _toDisplayString(formatPrice(montantTotal.value || 0)), 1)
                    ]),
                    (hasReduction.value && montantApresRemiseDisplay.value > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                          _cache[28] || (_cache[28] = _createElementVNode("span", { class: "text-black" }, "Remise HT (€) :", -1)),
                          _createElementVNode("span", _hoisted_95, "- " + _toDisplayString(formatPrice(montantTotal.value - montantApresRemiseDisplay.value)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (hasReduction.value && montantApresRemiseDisplay.value > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                          _cache[29] || (_cache[29] = _createElementVNode("span", { class: "text-black" }, "Prix Total HT après remise (€) :", -1)),
                          _createElementVNode("span", _hoisted_97, _toDisplayString(formatPrice(montantApresRemiseDisplay.value)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (!isEtranger.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                          _createElementVNode("span", _hoisted_99, "TVA (" + _toDisplayString(tvaRate.value * 100) + "%) (€) :", 1),
                          _createElementVNode("span", _hoisted_100, _toDisplayString(formatPrice(tvaAmount.value || 0)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (!isEtranger.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                          _cache[30] || (_cache[30] = _createElementVNode("span", { class: "text-black" }, "Prix total (€ TTC) :", -1)),
                          _createElementVNode("span", _hoisted_102, _toDisplayString(formatPrice(totalTTC.value || 0)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_103, [
                  _createElementVNode("div", _hoisted_104, [
                    _createElementVNode("div", _hoisted_105, [
                      _cache[31] || (_cache[31] = _createElementVNode("span", { class: "text-black" }, "Quantité totale :", -1)),
                      _createElementVNode("span", _hoisted_106, _toDisplayString(orderSummary.value.quantityTotal || 0), 1)
                    ]),
                    _createElementVNode("div", _hoisted_107, [
                      _cache[32] || (_cache[32] = _createElementVNode("span", { class: "text-black" }, "Poids total (kg):", -1)),
                      _createElementVNode("span", _hoisted_108, _toDisplayString(formatWeight(orderSummary.value.weight || 0)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_109, [
                      _cache[33] || (_cache[33] = _createElementVNode("span", { class: "text-black" }, "Nombre de colis :", -1)),
                      _createElementVNode("span", _hoisted_110, _toDisplayString(orderSummary.value.packages || 0), 1)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (remises.value && remises.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                _createElementVNode("div", _hoisted_112, [
                  _cache[38] || (_cache[38] = _createElementVNode("div", { class: "bg-gray-50 px-3 py-2 border-b border-gray-200" }, [
                    _createElementVNode("h4", { class: "text-sm font-semibold text-black" }, " Détail Remise / Code Promo ")
                  ], -1)),
                  _createElementVNode("div", _hoisted_113, [
                    _createElementVNode("table", _hoisted_114, [
                      _cache[37] || (_cache[37] = _createElementVNode("thead", { class: "bg-gray-50" }, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", { class: "px-3 py-2 text-left text-sm font-semibold text-black uppercase" }, " Libelle / Code "),
                          _createElementVNode("th", { class: "px-3 py-2 text-left text-sm font-semibold text-black uppercase" }, " Remise / Code promo "),
                          _createElementVNode("th", { class: "px-3 py-2 text-left text-sm font-semibold text-black uppercase" }, " Auteur "),
                          _createElementVNode("th", { class: "px-3 py-2 text-left text-sm font-semibold text-black uppercase" }, " Type "),
                          _createElementVNode("th", { class: "px-3 py-2 text-left text-sm font-semibold text-black uppercase" }, " Montant ")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", _hoisted_115, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(remisesCommandes.value, (remise) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: remise.id_commande_remise
                          }, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", _hoisted_116, _toDisplayString(remise.libelle || "-"), 1),
                              _createElementVNode("td", _hoisted_117, _toDisplayString(remise.typeRemise), 1),
                              _createElementVNode("td", _hoisted_118, _toDisplayString(remise.auteur), 1),
                              _createElementVNode("td", _hoisted_119, _toDisplayString(remise.type), 1),
                              _createElementVNode("td", _hoisted_120, _toDisplayString(remise.montant), 1)
                            ]),
                            (remise.auteur === 'Efashion')
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_121, _cache[34] || (_cache[34] = [
                                  _createElementVNode("td", {
                                    colspan: "5",
                                    class: "px-3 py-2"
                                  }, [
                                    _createElementVNode("div", { class: "bg-blue-50 border border-blue-200 rounded p-2 text-sm text-blue-800" }, " Cette commande bénéficie d'une remise Efashion que vous devez appliquer dans la facture. Le montant sera automatiquement déduit de la commission d'efashion sur la commande ")
                                  ], -1)
                                ])))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128)),
                        (remisesFraisPort.value.length > 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _cache[36] || (_cache[36] = _createElementVNode("tr", null, [
                                _createElementVNode("td", {
                                  colspan: "5",
                                  class: "px-3 py-2 text-center bg-gray-100"
                                }, [
                                  _createElementVNode("strong", { class: "text-sm text-black" }, "Partie Frais de port")
                                ])
                              ], -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(remisesFraisPort.value, (remise) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: remise.id_commande_remise
                                }, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("td", _hoisted_122, _toDisplayString(remise.libelle || "-"), 1),
                                    _createElementVNode("td", _hoisted_123, _toDisplayString(remise.typeRemise), 1),
                                    _createElementVNode("td", _hoisted_124, _toDisplayString(remise.auteur), 1),
                                    _createElementVNode("td", _hoisted_125, _toDisplayString(remise.type), 1),
                                    _createElementVNode("td", _hoisted_126, _toDisplayString(remise.montant), 1)
                                  ]),
                                  (remise.auteur === 'Efashion')
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_127, _cache[35] || (_cache[35] = [
                                        _createElementVNode("td", {
                                          colspan: "5",
                                          class: "px-3 py-2"
                                        }, [
                                          _createElementVNode("div", { class: "bg-blue-50 border border-blue-200 rounded p-2 text-sm text-blue-800" }, " Cette commande bénéficie d'une remise Efashion que vous devez appliquer dans la facture. Le montant sera automatiquement déduit de la commission d'efashion sur la commande ")
                                        ], -1)
                                      ])))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (canMarkRupture.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                _createElementVNode("button", {
                  onClick: openDiviserModal,
                  disabled: dividing.value || selectedProducts.value.length === 0,
                  "aria-busy": dividing.value,
                  class: _normalizeClass([
            'inline-flex items-center gap-2 px-4 py-2 rounded-md transition-colors disabled:opacity-60',
            selectedProducts.value.length === 0
              ? 'bg-gray-300 text-black cursor-not-allowed'
              : 'bg-red-600 text-white hover:bg-red-700',
          ]),
                  type: "button"
                }, [
                  (dividing.value)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_130))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(dividing.value ? 'Traitement…' : 'Rupture'), 1)
                ], 10, _hoisted_129)
              ]))
            : _createCommentVNode("", true),
          _createVNode(OrderReplacements, {
            ref_key: "replacementPanel",
            ref: replacementPanel,
            "order-id": _ctx.orderId,
            products: replacementProducts.value,
            "can-propose": canProposeReplacement.value,
            onSettled: _cache[1] || (_cache[1] = ($event: any) => (replacedLineIds.value = $event)),
            onChanged: onReplacementChanged,
            onReplacementConfirmation: _cache[2] || (_cache[2] = ($event: any) => (emit('replacementConfirmation', $event)))
          }, null, 8, ["order-id", "products", "can-propose"]),
          (productsRupture.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                _cache[54] || (_cache[54] = _createElementVNode("h4", { class: "text-sm font-semibold text-red-600 mb-3" }, " Références en rupture : ", -1)),
                (replacementUnavailableReason.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_132, _toDisplayString(replacementUnavailableReason.value), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_133, [
                  _createElementVNode("table", _hoisted_134, [
                    _cache[43] || (_cache[43] = _createElementVNode("thead", { class: "bg-gray-50/80" }, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", { class: "px-2 py-1.5 text-left text-xs font-semibold text-black uppercase tracking-wider" }, " Produit "),
                        _createElementVNode("th", { class: "px-2 py-1.5 text-center text-xs font-semibold text-black uppercase tracking-wider border-l border-r border-gray-200" }, " Taille "),
                        _createElementVNode("th", { class: "px-2 py-1.5 text-center text-xs font-semibold text-black uppercase tracking-wider border-r border-gray-200" }, " Qté commandée "),
                        _createElementVNode("th", { class: "px-2 py-1.5 text-center text-xs font-semibold text-black uppercase tracking-wider border-r border-gray-200" }, " Prix HT "),
                        _createElementVNode("th", { class: "px-2 py-1.5 text-center text-xs font-semibold text-black uppercase tracking-wider" }, " Poids (kg) "),
                        _createElementVNode("th", { class: "px-2 py-1.5 text-center text-xs font-semibold text-black uppercase tracking-wider border-l border-gray-200" }, " Action ")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", _hoisted_135, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productsRupture.value, (product) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: product.id,
                          class: "bg-red-100 hover:bg-red-200 transition-colors"
                        }, [
                          _createElementVNode("td", _hoisted_136, [
                            _createElementVNode("div", _hoisted_137, [
                              _createElementVNode("div", _hoisted_138, [
                                (getImageUrlForProduct(product))
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: getImageUrlForProduct(product),
                                      alt: product.reference,
                                      class: "w-full h-full object-cover cursor-pointer hover:opacity-90 transition-opacity",
                                      loading: "lazy",
                                      onError: handleImageError,
                                      onClick: ($event: any) => (
                          openImageModal(
                            getImageUrlForProduct(product),
                            product.reference,
                          )
                        )
                                    }, null, 40, _hoisted_139))
                                  : (_openBlock(), _createElementBlock("i", _hoisted_140))
                              ]),
                              _createElementVNode("div", _hoisted_141, [
                                _createElementVNode("p", _hoisted_142, [
                                  _cache[39] || (_cache[39] = _createElementVNode("span", { class: "font-medium text-black" }, "Réf: ", -1)),
                                  _createElementVNode("span", _hoisted_143, _toDisplayString(product.reference || "-"), 1)
                                ]),
                                _createElementVNode("p", _hoisted_144, [
                                  _cache[40] || (_cache[40] = _createElementVNode("span", { class: "font-medium text-black" }, "Catégorie: ", -1)),
                                  _createElementVNode("span", _hoisted_145, _toDisplayString(product.categorie || "-"), 1)
                                ]),
                                _createElementVNode("p", _hoisted_146, [
                                  _cache[41] || (_cache[41] = _createElementVNode("span", { class: "font-medium text-black" }, "Prix: ", -1)),
                                  (product.hasRemise && product.priceUnitNormal)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("span", _hoisted_147, _toDisplayString(formatPrice(product.priceUnitNormal)) + "€", 1),
                                        _createElementVNode("span", _hoisted_148, _toDisplayString(formatPrice(product.priceUnit || 0)) + "€", 1)
                                      ], 64))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_149, _toDisplayString(formatPrice(product.priceUnit || 0)) + "€", 1))
                                ]),
                                _createElementVNode("p", _hoisted_150, [
                                  _cache[42] || (_cache[42] = _createElementVNode("span", { class: "font-medium text-black" }, "Couleur: ", -1)),
                                  (hasOfficialColorSwatch(product))
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: "color-swatch-dot inline-block w-3.5 h-3.5 rounded-full flex-shrink-0",
                                        style: _normalizeStyle(getOfficialColorSwatchStyle(product)),
                                        title: product.colorFR || product.color || ''
                                      }, null, 12, _hoisted_151))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("span", _hoisted_152, _toDisplayString(product.colorFR || product.color || "-"), 1)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_153, [
                            (getProductSizeRows(product).length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_154, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getProductSizeRows(product), (row) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: row.label,
                                      class: "flex flex-col items-center gap-0.5"
                                    }, [
                                      _createElementVNode("span", _hoisted_155, _toDisplayString(row.label), 1),
                                      _createElementVNode("span", _hoisted_156, _toDisplayString(row.qty), 1)
                                    ]))
                                  }), 128))
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_157, "—"))
                          ]),
                          _createElementVNode("td", _hoisted_158, [
                            _createElementVNode("p", _hoisted_159, _toDisplayString(getOrderedQuantityLabel(product)), 1)
                          ]),
                          _createElementVNode("td", _hoisted_160, [
                            _createElementVNode("p", _hoisted_161, _toDisplayString(formatPrice(product.priceLineHT || product.price || 0)) + "€ ", 1)
                          ]),
                          _createElementVNode("td", _hoisted_162, [
                            _createElementVNode("p", _hoisted_163, _toDisplayString(formatWeight(product.weightTotal || product.weight || 0)), 1)
                          ]),
                          _createElementVNode("td", _hoisted_164, [
                            (canReactivate.value && !replacedLineIds.value.includes(product.id))
                              ? (_openBlock(), _createElementBlock("input", {
                                  key: 0,
                                  type: "checkbox",
                                  checked: selectedProductsRupture.value.includes(product.id),
                                  onChange: ($event: any) => (toggleProductRupture(product.id)),
                                  class: "w-3.5 h-3.5 text-blue-600 bg-white border-gray-300 rounded focus:ring-1 focus:ring-blue-500 cursor-pointer"
                                }, null, 40, _hoisted_165))
                              : _createCommentVNode("", true),
                            (replacedLineIds.value.includes(product.id))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_166, "Proposé / remplacé — voir la proposition"))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_167, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productsRupture.value, (product) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: product.id
                    }, [
                      _createElementVNode("div", _hoisted_168, [
                        _createElementVNode("div", _hoisted_169, [
                          _createElementVNode("div", _hoisted_170, [
                            _createElementVNode("div", _hoisted_171, [
                              _cache[44] || (_cache[44] = _createTextVNode(" Réf:  ")),
                              _createElementVNode("span", _hoisted_172, _toDisplayString(product.reference || "-"), 1)
                            ]),
                            (canReactivate.value && !replacedLineIds.value.includes(product.id))
                              ? (_openBlock(), _createElementBlock("input", {
                                  key: 0,
                                  type: "checkbox",
                                  checked: selectedProductsRupture.value.includes(product.id),
                                  "aria-label": `Sélectionner le produit en rupture ${product.reference || product.id}`,
                                  onChange: ($event: any) => (toggleProductRupture(product.id)),
                                  class: "w-6 h-6 mt-1 min-[601px]:mt-2 flex-shrink-0 text-blue-600 bg-white border-gray-300 rounded focus:ring-2 focus:ring-blue-500 cursor-pointer"
                                }, null, 40, _hoisted_173))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_174, [
                            _cache[45] || (_cache[45] = _createTextVNode(" Catégorie : ")),
                            _createElementVNode("span", null, _toDisplayString(product.categorie || "-"), 1)
                          ]),
                          (replacedLineIds.value.includes(product.id))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_175, "Proposé / remplacé — voir la proposition"))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_176, [
                          _createElementVNode("div", _hoisted_177, [
                            _createElementVNode("div", _hoisted_178, [
                              (getImageUrlForProduct(product))
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: getImageUrlForProduct(product),
                                    alt: product.reference,
                                    class: "w-full h-full object-contain min-[601px]:object-cover cursor-pointer hover:opacity-90 transition-opacity",
                                    loading: "lazy",
                                    onError: handleImageError,
                                    onClick: ($event: any) => (
                        openImageModal(
                          getImageUrlForProduct(product),
                          product.reference,
                        )
                      )
                                  }, null, 40, _hoisted_179))
                                : (_openBlock(), _createElementBlock("i", _hoisted_180))
                            ]),
                            _createElementVNode("div", _hoisted_181, [
                              _createElementVNode("p", _hoisted_182, [
                                _cache[46] || (_cache[46] = _createTextVNode(" Couleur: ")),
                                (hasOfficialColorSwatch(product))
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: "color-swatch-dot inline-block w-3.5 h-3.5 rounded-full flex-shrink-0",
                                      style: _normalizeStyle(getOfficialColorSwatchStyle(product)),
                                      title: product.colorFR || product.color || ''
                                    }, null, 12, _hoisted_183))
                                  : _createCommentVNode("", true),
                                _createTextVNode(" " + _toDisplayString(product.colorFR || product.color || "-"), 1)
                              ]),
                              _createElementVNode("div", _hoisted_184, [
                                (getProductSizeRows(product).length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_185, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getProductSizeRows(product), (row) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: row.label,
                                          class: "flex flex-col items-center gap-0.5"
                                        }, [
                                          _createElementVNode("span", _hoisted_186, _toDisplayString(row.label), 1),
                                          _createElementVNode("span", _hoisted_187, _toDisplayString(row.qty), 1)
                                        ]))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_188, [
                                  _cache[47] || (_cache[47] = _createElementVNode("div", { class: "mb-0.5" }, "Qté commandée", -1)),
                                  _createElementVNode("div", _hoisted_189, _toDisplayString(getOrderedQuantityLabel(product)), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_190, [
                                _createElementVNode("div", _hoisted_191, [
                                  _cache[48] || (_cache[48] = _createElementVNode("div", { class: "mb-0.5" }, "Prix HT:", -1)),
                                  _createElementVNode("div", _hoisted_192, [
                                    (product.hasRemise && product.priceUnitNormal)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_193, _toDisplayString(formatPrice(product.priceUnitNormal)) + "€", 1))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("span", null, _toDisplayString(formatPrice(product.priceUnit || 0)) + "€", 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_194, [
                                  _cache[49] || (_cache[49] = _createElementVNode("div", { class: "mb-0.5" }, "Total:", -1)),
                                  _createElementVNode("span", _hoisted_195, _toDisplayString(formatPrice(product.priceLineHT || product.price || 0)) + "€", 1)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_196, [
                  _createElementVNode("div", _hoisted_197, [
                    _createElementVNode("div", _hoisted_198, [
                      _createElementVNode("div", _hoisted_199, [
                        _cache[50] || (_cache[50] = _createElementVNode("span", { class: "text-black" }, "Prix total (€) :", -1)),
                        _createElementVNode("span", _hoisted_200, _toDisplayString(formatPrice(totalRuptureHT.value)), 1)
                      ]),
                      (!isEtranger.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_201, [
                            _createElementVNode("span", _hoisted_202, "TVA (" + _toDisplayString(tvaRate.value * 100) + "%) (€) :", 1),
                            _createElementVNode("span", _hoisted_203, _toDisplayString(formatPrice(tvaAmountRupture.value || 0)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (!isEtranger.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_204, [
                            _cache[51] || (_cache[51] = _createElementVNode("span", { class: "text-black" }, "Prix total (€ TTC) :", -1)),
                            _createElementVNode("span", _hoisted_205, _toDisplayString(formatPrice(totalRuptureTTC.value || 0)), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_206, [
                    _createElementVNode("div", _hoisted_207, [
                      _createElementVNode("div", _hoisted_208, [
                        _cache[52] || (_cache[52] = _createElementVNode("span", { class: "text-black" }, "Quantité totale :", -1)),
                        _createElementVNode("span", _hoisted_209, _toDisplayString(totalRuptureQuantite.value), 1)
                      ]),
                      _createElementVNode("div", _hoisted_210, [
                        _cache[53] || (_cache[53] = _createElementVNode("span", { class: "text-black" }, "Poids total (kg):", -1)),
                        _createElementVNode("span", _hoisted_211, _toDisplayString(formatWeight(totalRupturePoids.value)), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_212, [
                  _createElementVNode("button", {
                    type: "button",
                    disabled: !canProposeReplacement.value || !productsRupture.value.some(p => !replacedLineIds.value.includes(p.id)),
                    title: replacementUnavailableReason.value || undefined,
                    class: "mr-3 px-4 py-2 rounded-md bg-indigo-600 text-white disabled:opacity-50 disabled:cursor-not-allowed",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (replacementPanel.value?.open()))
                  }, "Proposer des remplacements", 8, _hoisted_213),
                  (canReactivate.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: openReactiveModal,
                        disabled: reactivableSelection.value.length === 0,
                        class: _normalizeClass([
              'px-4 py-2 rounded-md transition-colors',
              reactivableSelection.value.length === 0
                ? 'bg-gray-300 text-black cursor-not-allowed'
                : 'bg-green-600 text-white hover:bg-green-700',
            ])
                      }, " Réactiver ", 10, _hoisted_214))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_unref(ModalComp), {
            isVisible: showReactiveModal.value,
            "onUpdate:isVisible": _cache[5] || (_cache[5] = ($event: any) => ((showReactiveModal).value = $event)),
            title: "Réactiver",
            content: "Êtes-vous sûr de vouloir réactiver des produits de cette commande ?",
            "confirm-text": "Confirmer",
            "cancel-text": "Annuler",
            size: "sm",
            onConfirm: confirmReactive
          }, {
            footer: _withCtx(() => [
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (showReactiveModal.value = false)),
                class: "px-4 py-2 text-sm border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors",
                type: "button"
              }, " Annuler "),
              _createElementVNode("button", {
                onClick: confirmReactive,
                class: "px-4 py-2 text-sm bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors",
                type: "button"
              }, " Confirmer ")
            ]),
            _: 1
          }, 8, ["isVisible"]),
          _createVNode(_unref(ModalComp), {
            isVisible: showDiviserModal.value,
            "onUpdate:isVisible": _cache[7] || (_cache[7] = ($event: any) => ((showDiviserModal).value = $event)),
            title: "Diviser les paquets",
            size: "lg"
          }, {
            body: _withCtx(() => [
              (lignesADiviser.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_215, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lignesADiviser.value, (ligne) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: ligne.id_ligne,
                        class: "border rounded-lg p-4"
                      }, [
                        _createElementVNode("div", _hoisted_216, [
                          _createElementVNode("h4", _hoisted_217, _toDisplayString(ligne.reference), 1),
                          _createElementVNode("div", _hoisted_218, [
                            _createElementVNode("span", _hoisted_219, "Prix HT unitaire: " + _toDisplayString(formatPrice(ligne.prixUnitaire)) + "€", 1),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (remplirRuptureTotale(ligne)),
                              disabled: isRuptureTotale(ligne),
                              class: _normalizeClass([
                      'w-full px-3 py-2 text-sm rounded-lg transition-colors sm:w-auto sm:py-1.5',
                      isRuptureTotale(ligne)
                        ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
                        : 'bg-red-600 text-white hover:bg-red-700',
                    ]),
                              type: "button"
                            }, " Tout mettre en rupture ", 10, _hoisted_220)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_221, [
                          _createElementVNode("table", _hoisted_222, [
                            _createElementVNode("thead", null, [
                              _createElementVNode("tr", _hoisted_223, [
                                _cache[55] || (_cache[55] = _createElementVNode("th", { class: "border px-2 py-1 text-left text-black" }, " Déclinaison ", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ligne.declinaisonsLabels, (label, index) => {
                                  return (_openBlock(), _createElementBlock("th", {
                                    key: index,
                                    class: "border px-2 py-1 text-center text-black"
                                  }, _toDisplayString(label || `Q${index + 1}`), 1))
                                }), 128)),
                                _cache[56] || (_cache[56] = _createElementVNode("th", { class: "border px-2 py-1 text-center text-black" }, " Prix HT ", -1))
                              ])
                            ]),
                            _createElementVNode("tbody", null, [
                              _createElementVNode("tr", null, [
                                _cache[57] || (_cache[57] = _createElementVNode("td", { class: "border px-2 py-1 font-medium text-black" }, " Commande ", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ligne.base_qt, (qty, index) => {
                                  return (_openBlock(), _createElementBlock("td", {
                                    key: index,
                                    class: "border px-2 py-1"
                                  }, [
                                    _createElementVNode("input", {
                                      type: "number",
                                      value: ligne.base_qt[index],
                                      readonly: "",
                                      class: "w-full px-2 py-1 border rounded text-center bg-gray-50 cursor-not-allowed"
                                    }, null, 8, _hoisted_224)
                                  ]))
                                }), 128)),
                                _createElementVNode("td", _hoisted_225, [
                                  _createElementVNode("input", {
                                    type: "number",
                                    value: ligne.base_prixligne,
                                    step: "0.01",
                                    readonly: "",
                                    class: "w-full px-2 py-1 border rounded text-center bg-gray-50 cursor-not-allowed"
                                  }, null, 8, _hoisted_226)
                                ])
                              ]),
                              _createElementVNode("tr", null, [
                                _cache[58] || (_cache[58] = _createElementVNode("td", { class: "border px-2 py-1 font-medium text-black" }, " Rupture ", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ligne.qt, (qty, index) => {
                                  return (_openBlock(), _createElementBlock("td", {
                                    key: index,
                                    class: "border px-2 py-1"
                                  }, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      "onUpdate:modelValue": ($event: any) => ((ligne.qt[index]) = $event),
                                      onInput: ($event: any) => (updateDiviserPrix(ligne)),
                                      min: 0,
                                      max: ligne.quantitesOriginales[index],
                                      class: "w-full px-2 py-1 border rounded text-center"
                                    }, null, 40, _hoisted_227), [
                                      [
                                        _vModelText,
                                        ligne.qt[index],
                                        void 0,
                                        { number: true }
                                      ]
                                    ])
                                  ]))
                                }), 128)),
                                _createElementVNode("td", _hoisted_228, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    "onUpdate:modelValue": ($event: any) => ((ligne.prixligne) = $event),
                                    onInput: ($event: any) => (updateDiviserManualPrice(ligne)),
                                    step: "0.01",
                                    min: "0",
                                    max: ligne.prixOriginal,
                                    readonly: !isAdmin.value,
                                    class: _normalizeClass([
                            'w-full px-2 py-1 border rounded text-center',
                            !isAdmin.value
                              ? 'bg-gray-50 cursor-not-allowed'
                              : 'bg-white',
                          ])
                                  }, null, 42, _hoisted_229), [
                                    [
                                      _vModelText,
                                      ligne.prixligne,
                                      void 0,
                                      { number: true }
                                    ]
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_230, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ligne.declinaisonsLabels, (label, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "rounded-lg border border-gray-200 bg-gray-50 p-3"
                            }, [
                              _createElementVNode("div", _hoisted_231, _toDisplayString(label || `Q${index + 1}`), 1),
                              _createElementVNode("div", _hoisted_232, [
                                _createElementVNode("label", _hoisted_233, [
                                  _cache[59] || (_cache[59] = _createElementVNode("span", { class: "mb-1 block text-xs font-medium text-gray-600" }, " Commande ", -1)),
                                  _createElementVNode("input", {
                                    type: "number",
                                    value: ligne.base_qt[index],
                                    readonly: "",
                                    class: "w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-center text-base text-black cursor-not-allowed"
                                  }, null, 8, _hoisted_234)
                                ]),
                                _createElementVNode("label", _hoisted_235, [
                                  _cache[60] || (_cache[60] = _createElementVNode("span", { class: "mb-1 block text-xs font-medium text-red-700" }, " Rupture ", -1)),
                                  _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    "onUpdate:modelValue": ($event: any) => ((ligne.qt[index]) = $event),
                                    onInput: ($event: any) => (updateDiviserPrix(ligne)),
                                    min: 0,
                                    max: ligne.quantitesOriginales[index],
                                    inputmode: "numeric",
                                    class: "w-full rounded-lg border border-red-300 bg-white px-3 py-2 text-center text-base text-black focus:border-red-500 focus:ring-2 focus:ring-red-200"
                                  }, null, 40, _hoisted_236), [
                                    [
                                      _vModelText,
                                      ligne.qt[index],
                                      void 0,
                                      { number: true }
                                    ]
                                  ])
                                ])
                              ])
                            ]))
                          }), 128)),
                          _createElementVNode("div", _hoisted_237, [
                            _createElementVNode("label", _hoisted_238, [
                              _cache[61] || (_cache[61] = _createElementVNode("span", { class: "mb-1 block text-xs font-medium text-gray-600" }, " Prix commande HT ", -1)),
                              _createElementVNode("input", {
                                type: "number",
                                value: ligne.base_prixligne,
                                step: "0.01",
                                readonly: "",
                                class: "w-full rounded-lg border border-gray-300 bg-gray-50 px-3 py-2 text-right text-base text-black cursor-not-allowed"
                              }, null, 8, _hoisted_239)
                            ]),
                            _createElementVNode("label", _hoisted_240, [
                              _cache[62] || (_cache[62] = _createElementVNode("span", { class: "mb-1 block text-xs font-medium text-red-700" }, " Prix rupture HT ", -1)),
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                "onUpdate:modelValue": ($event: any) => ((ligne.prixligne) = $event),
                                onInput: ($event: any) => (updateDiviserManualPrice(ligne)),
                                step: "0.01",
                                min: "0",
                                max: ligne.prixOriginal,
                                readonly: !isAdmin.value,
                                class: _normalizeClass([
                        'w-full rounded-lg border px-3 py-2 text-right text-base text-black',
                        !isAdmin.value
                          ? 'border-gray-300 bg-gray-50 cursor-not-allowed'
                          : 'border-red-300 bg-white focus:border-red-500 focus:ring-2 focus:ring-red-200',
                      ])
                              }, null, 42, _hoisted_241), [
                                [
                                  _vModelText,
                                  ligne.prixligne,
                                  void 0,
                                  { number: true }
                                ]
                              ])
                            ])
                          ])
                        ]),
                        (ligne.error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_242, _toDisplayString(ligne.error), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_243, " Aucune ligne sélectionnée "))
            ]),
            footer: _withCtx(() => [
              _createElementVNode("button", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (showDiviserModal.value = false)),
                disabled: dividing.value,
                class: "px-4 py-2 text-sm border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors",
                type: "button"
              }, " Annuler ", 8, _hoisted_244),
              _createElementVNode("button", {
                onClick: confirmDiviser,
                disabled: dividing.value || !canConfirmDiviser.value,
                "aria-busy": dividing.value,
                class: _normalizeClass([
              'inline-flex items-center gap-2 px-4 py-2 text-sm rounded-lg transition-colors disabled:opacity-60',
              canConfirmDiviser.value
                ? 'bg-green-600 text-white hover:bg-green-700'
                : 'bg-gray-300 text-black cursor-not-allowed',
            ]),
                type: "button"
              }, [
                (dividing.value)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_246))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(dividing.value ? 'Traitement…' : 'Sauvegarder'), 1)
              ], 10, _hoisted_245)
            ]),
            _: 1
          }, 8, ["isVisible"])
        ], 34)
      ]),
      _: 1
    }, 8, ["title"]),
    (canMarkRupture.value && selectedProducts.value.length > 0 && !showDiviserModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_247, [
          _createElementVNode("div", _hoisted_248, [
            _createElementVNode("div", _hoisted_249, _toDisplayString(selectedProducts.value.length) + " " + _toDisplayString(selectedProducts.value.length > 1
            ? "références sélectionnées"
            : "référence sélectionnée"), 1),
            _cache[63] || (_cache[63] = _createElementVNode("div", { class: "text-xs text-gray-500" }, "Créer une rupture de stock", -1))
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "flex flex-shrink-0 items-center gap-2 rounded-lg bg-red-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-red-700 focus:ring-2 focus:ring-red-300 disabled:opacity-60",
            disabled: dividing.value,
            "aria-busy": dividing.value,
            onClick: openDiviserModal
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(dividing.value ? 'fas fa-spinner fa-spin' : 'fas fa-box-open'),
              "aria-hidden": "true"
            }, null, 2),
            _createTextVNode(" " + _toDisplayString(dividing.value ? 'Traitement…' : 'Rupture'), 1)
          ], 8, _hoisted_250)
        ]))
      : _createCommentVNode("", true),
    (showImageModal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "fixed inset-0 z-[9999] overflow-y-auto",
          onWheelPassive: () => {}
        }, [
          _createElementVNode("div", _hoisted_251, [
            _createElementVNode("div", {
              class: "fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75",
              onClick: closeImageModal
            }),
            _createElementVNode("div", _hoisted_252, [
              _createElementVNode("div", _hoisted_253, [
                _createElementVNode("h3", _hoisted_254, _toDisplayString(selectedImageAlt.value), 1),
                _createElementVNode("button", {
                  onClick: closeImageModal,
                  class: "text-black hover:text-black transition-colors",
                  type: "button"
                }, _cache[64] || (_cache[64] = [
                  _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                ]))
              ]),
              _createElementVNode("div", _hoisted_255, [
                (selectedImageUrl.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: selectedImageUrl.value,
                      alt: selectedImageAlt.value,
                      class: "max-w-full max-h-96 object-contain rounded-lg",
                      onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
                    }, null, 8, _hoisted_256))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ], 32))
      : _createCommentVNode("", true),
    _createVNode(_unref(ConfirmModal), {
      show: showDeleteCommentModal.value,
      title: "Supprimer le commentaire",
      message: "Voulez-vous vraiment supprimer ce commentaire ?",
      confirmText: "Supprimer",
      confirmButtonClass: "bg-red-600 hover:bg-red-700 focus:ring-red-500",
      showAttentionIcon: true,
      onConfirm: confirmDeleteAdminCommentaire,
      onCancel: cancelDeleteAdminCommentaire
    }, null, 8, ["show"])
  ], 64))
}
}

})